import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export default function showErrMessage(text) {
  toast.error(text, {
    position: toast.POSITION.TOP_RIGHT,
  });
}
